<template>
  <div
    class="d-flex align-items-start mb-2 cursor-pointer notification-item"
    :class="{ 'notification-read': notification.visualizada }"
    @click="handleClick"
  >
    <div class="avatar mr-1">
      <feather-icon
        icon="BellIcon"
        size="20"
        class="text-primary"
      />
    </div>
    <div class="notification-content">
      <h6 class="font-weight-bold mb-0">
        {{ notification.titulo }}
      </h6>
      <p class="text-muted mb-0">
        {{ notification.descricao.length > 90 ? notification.descricao.substring(0, 90) + '...' : notification.descricao }}
      </p>
      <div class="d-flex justify-content-between align-items-center mt-1">
        <small class="text-muted">{{ notification.dataCadastro }}</small>
        <span
          v-if="notification.visualizada"
          class="text-muted"
        > - Lida</span>
        <span
          v-else
          class="text-danger"
        > - Não Lida</span>
      </div>
    </div>
  </div>
</template>

<script>
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'

export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async handleClick() {
      try {
        await api.marcarComoLida(this.notification.id).then(() => {
          this.notification.visualizada = true
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erro ao marcar notificação como lida: ${error.message}`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        })

        this.$emit('notification-clicked', this.notification.id)
        this.$emit('open-notification-modal', this.notification)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Erro ao marcar notificação como lida: ${error.message}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString(undefined, options)
    },
  },
}
</script>

<style scoped>
.d-flex {
  display: flex;
}
.align-items-start {
  align-items: flex-start;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.cursor-pointer {
  cursor: pointer;
}
.notification-read {
  opacity: 0.6;
}
.avatar {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 50%;
}
.notification-content {
  flex: 1;
}
.font-weight-bold {
  font-weight: bold;
}
.text-muted {
  color: #6c757d;
}
.notification-item {
  padding: 1rem;
  border: 2px solid gold;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}
.notification-item:hover {
  background-color: rgba(255, 215, 0, 0.2); /* Fundo dourado claro ao passar o mouse */
}
</style>
